import { LayoutPanelLeft } from "lucide-react"

import { type DataSourcesTabProps, DataSourcesTab } from "./DataSourcesTab"
import { type FieldsTabProps, FieldsTab } from "./FieldsTab"
import { type FiltersTabProps, FiltersTab } from "./FiltersTab"
import { type LayoutEditorTabContentProps, LayoutEditorTabContent } from "./LayoutEditorTabContent"
import { Card, CardContent } from "shared/ui/card"
import { Tabs, TabsContent, TabsList, TabsTrigger } from "shared/ui/tabs"

export interface ReportTemplateDefinitionTabsProps {
  datasourcesCount: number
  fieldsCount: number
  filtersCount: number
  layoutWidgetCount: number
  datasourcesTabProps: DataSourcesTabProps
  fieldsTabProps: FieldsTabProps
  filtersTabProps: FiltersTabProps
  layoutTabProps: LayoutEditorTabContentProps
}

export function ReportTemplateDefinitionTabs({
  datasourcesCount,
  fieldsCount,
  filtersCount,
  layoutWidgetCount,
  datasourcesTabProps,
  fieldsTabProps,
  filtersTabProps,
  layoutTabProps,
}: ReportTemplateDefinitionTabsProps) {
  return (
    <Card>
      <CardContent className="py-6">
        <Tabs defaultValue="fields" className="space-y-4">
          <TabsList>
            <TabsTrigger value="datasources">Data Sources ({datasourcesCount})</TabsTrigger>
            <TabsTrigger value="fields">Fields ({fieldsCount})</TabsTrigger>
            <TabsTrigger value="filters">Filters ({filtersCount})</TabsTrigger>
            <TabsTrigger value="layout" className="gap-2">
              <LayoutPanelLeft className="h-4 w-4" />
              Layout ({layoutWidgetCount})
            </TabsTrigger>
          </TabsList>

          <TabsContent value="datasources">
            <DataSourcesTab {...datasourcesTabProps} />
          </TabsContent>

          <TabsContent value="fields">
            <FieldsTab {...fieldsTabProps} />
          </TabsContent>

          <TabsContent value="filters">
            <FiltersTab {...filtersTabProps} />
          </TabsContent>

          <TabsContent value="layout">
            <LayoutEditorTabContent {...layoutTabProps} />
          </TabsContent>
        </Tabs>
      </CardContent>
    </Card>
  )
}

